import { useDraftProvider } from '../../../Draft'
import { RentalPortalListingDraft } from '../../RentalPortalListing.context'

function RentalPortalListingDraftProvider({
  DraftContext = RentalPortalListingDraft,
  children,
  prefix,
}) {
  const value = useDraftProvider({ draftId: prefix })

  return <DraftContext value={value}>{children}</DraftContext>
}

export default RentalPortalListingDraftProvider
